import { ChangeEvent, FC } from 'react';
import { validateEmail } from '../../utils/check-email';
import InputText from './input-text';

const InputEmail: FC<{
    id: string;
    label: string;
    onChange: (event: ChangeEvent) => void;
    value: string | undefined;
    error: boolean;
    variant: 'standard' | 'outlined' | 'filled' | undefined;
    fullWidth: boolean;
    setError: (value: string) => void;
    helperText: string | undefined;
}> = ({ id, label, onChange, value, error, variant, fullWidth, setError, helperText }) => {
    return (
        <InputText
            id={id}
            label={label}
            onChange={(event: ChangeEvent) => {
                setError('');
                onChange(event);
            }}
            onBlur={() => {
                const isEmailValid: boolean = validateEmail(value);
                if (!isEmailValid) {
                    setError('error.email.invalid');
                }
            }}
            value={value ?? ''}
            variant={variant}
            fullWidth={fullWidth}
            error={error}
            helperText={helperText}
        />
    );
};

export default InputEmail;
